import type { FaireProductEntity } from "../../entity_types/product";

export const p_tv5bggqrq5: FaireProductEntity = {
  token: "p_tv5bggqrq5",
  type: "product",
  name: "Luna Moth Socks Cotton Blend",
  brandToken: "b_75gfjzdxd9",
  brandName: "Happily Plants",
  imageUrl:
    "https://cdn.faire.com/fastly/b1cea924681f9c89c14898bcd7d0ceea71314b244253f1482370ff9de386d204.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/04ccab16a5d8a934e6145849de49cca837851b16983d10ffd7cce94aa8661656.jpeg",
    "https://cdn.faire.com/fastly/1e5295ced4e8c492cf49bdbc2010532a05d4575285995fc7cb2aeb0fcc0a9606.jpeg",
    "https://cdn.faire.com/fastly/f4623f2c57c3541071202bd1f377a26fdaa34c208f240133dd1cccebdc1a33f5.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Luna Moth Socks bring art to your feet. Designed by Holly in her New Jersey studio, these socks are a piece of wearable art. The whimsical pattern, hand-drawn with care, transforms the ordinary into something extraordinary. These aren't just socks. They're a celebration of the everyday. Unisex and made from a comfortable cotton blend, they're perfect for adding a touch of joy to your daily routine. Choose happiness with Happily Plants.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:35.746Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
